"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.diseasesMessages = exports.hasDiseaseMessages = exports.Diseases = exports.HasDisease = void 0;
const schema_1 = require("../../../../schema");
var HasDisease;
(function (HasDisease) {
    HasDisease["HAS_NEPHRECTOMY_GRAFTECTOMY_DISEASE"] = "has_nephrectomy_graftectomy_disease";
    HasDisease["NO_UNKNOWN_NEPHRECTOMY_GRAFTECTOMY_DISEASE"] = "no_unknown_nephrectomy_graftectomy_disease";
})(HasDisease || (exports.HasDisease = HasDisease = {}));
var Diseases;
(function (Diseases) {
    Diseases["NEPHRECTOMY_LS"] = "nephrectomy_ls";
    Diseases["NEPHRECTOMY_LD"] = "nephrectomy_ld";
    Diseases["NEPHRECTOMY_LU"] = "nephrectomy_lu";
    Diseases["GRAFTECTOMY_LD"] = "graftectomy_ld";
    Diseases["GRAFTECTOMY_LS"] = "graftectomy_ls";
})(Diseases || (exports.Diseases = Diseases = {}));
exports.hasDiseaseMessages = {
    [HasDisease.HAS_NEPHRECTOMY_GRAFTECTOMY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.nephrectomyOrGraftectomy.hasDisease.HAS_NEPHRECTOMY_GRAFTECTOMY_DISEASE",
        defaultMessage: "Diagnosztizált Nephrectomia / Graftectomia betegség"
    },
    [HasDisease.NO_UNKNOWN_NEPHRECTOMY_GRAFTECTOMY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.nephrectomyOrGraftectomy.hasDisease.NO_UNKNOWN_NEPHRECTOMY_GRAFTECTOMY_DISEASE",
        defaultMessage: "Nincs vagy nem ismert"
    }
};
exports.diseasesMessages = {
    [Diseases.NEPHRECTOMY_LS]: {
        id: "ktx.transplantationScreening.medicalHistory.nephrectomyOrGraftectomy.diseases.NEPHRECTOMY_LS",
        defaultMessage: "Nephrectomia ls"
    },
    [Diseases.NEPHRECTOMY_LD]: {
        id: "ktx.transplantationScreening.medicalHistory.nephrectomyOrGraftectomy.diseases.NEPHRECTOMY_LD",
        defaultMessage: "Nephrectomia ld"
    },
    [Diseases.NEPHRECTOMY_LU]: {
        id: "ktx.transplantationScreening.medicalHistory.nephrectomyOrGraftectomy.diseases.NEPHRECTOMY_LU",
        defaultMessage: "Nephrectomia lu"
    },
    [Diseases.GRAFTECTOMY_LD]: {
        id: "ktx.transplantationScreening.medicalHistory.nephrectomyOrGraftectomy.diseases.GRAFTECTOMY_LD",
        defaultMessage: "Graftectomia ld"
    },
    [Diseases.GRAFTECTOMY_LS]: {
        id: "ktx.transplantationScreening.medicalHistory.nephrectomyOrGraftectomy.diseases.GRAFTECTOMY_LS",
        defaultMessage: "Graftectomia ls"
    }
};
const hasDisease = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HasDisease.HAS_NEPHRECTOMY_GRAFTECTOMY_DISEASE).interpretation({
        vocab: "ktx",
        code: "has_nephrectomy_graftectomy_disease"
    }),
    schema_1.Schema.singleChoiceItem(HasDisease.NO_UNKNOWN_NEPHRECTOMY_GRAFTECTOMY_DISEASE)
        .interpretation({
        vocab: "ktx",
        code: "no_unknown_nephrectomy_graftectomy_disease"
    })
        .tag({ vocab: "ktx", code: "graftectomy" })
]).interpretation({
    vocab: "ktx",
    code: "has_nephrectomy_graftectomy_disease_choice"
});
const diseases = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../hasDisease} === "has_nephrectomy_graftectomy_disease"`), schema_1.Schema.multiChoice([
    schema_1.Schema.multiChoiceItem(Diseases.NEPHRECTOMY_LS)
        .interpretation({ vocab: "ktx", code: "nephrectomy_ls" })
        .tag({ vocab: "ktx", code: "nephrectomy" })
        .tag({ vocab: "snomed", code: "265550007" }),
    schema_1.Schema.multiChoiceItem(Diseases.NEPHRECTOMY_LD)
        .interpretation({ vocab: "ktx", code: "nephrectomy_ld" })
        .tag({ vocab: "ktx", code: "nephrectomy" })
        .tag({ vocab: "snomed", code: "265550007" }),
    schema_1.Schema.multiChoiceItem(Diseases.NEPHRECTOMY_LU)
        .interpretation({ vocab: "ktx", code: "nephrectomy_lu" })
        .tag({ vocab: "ktx", code: "nephrectomy" })
        .tag({ vocab: "snomed", code: "265550007" }),
    schema_1.Schema.multiChoiceItem(Diseases.GRAFTECTOMY_LD)
        .interpretation({ vocab: "ktx", code: "graftectomy_ld" })
        .tag({ vocab: "ktx", code: "graftectomy" }),
    schema_1.Schema.multiChoiceItem(Diseases.GRAFTECTOMY_LS)
        .interpretation({ vocab: "ktx", code: "graftectomy_ls" })
        .tag({ vocab: "ktx", code: "graftectomy" })
]));
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ hasDisease, diseases })
    .interpretation({ vocab: "ktx", code: "nephrectomy_graftectomy" });
